import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import toClipboard from 'copy-to-clipboard';

import { hideExportCustomReportInsertQueryModal } from './store/actions';
import { useCustomReportInsertQuery } from '../../shared/queries/customReports';
import Modal from '../../shared/modals/modal.component';

import Config from '../../config';

type ExportCustomRepostInsertQueryModalProps = {
  isVisible: false,
  reportSetId?: string,
}

const useHideModal = () => {
  const dispatch = useDispatch();

  const hideModal = useCallback(() => {
    dispatch(hideExportCustomReportInsertQueryModal());
  }, [dispatch]);

  return hideModal;
};

export const ExportCustomRepostInsertQueryModal = ({
  reportSetId,
  isVisible,
}: ExportCustomRepostInsertQueryModalProps) => {
  const { data: { query }, isFetching } = useCustomReportInsertQuery({ reportSetId, enabled: isVisible });

  const hideModal = useHideModal();

  const copyToClipboard = useCallback(() => {
    toClipboard(query);
    toastr.success('', 'Query copied to clipboard', Config.defaultToastrSettings);
  }, [query]);

  const copyToClipboardAndClose = useCallback(() => {
    copyToClipboard();
    hideModal();
  }, [copyToClipboard, hideModal]);

  if (!isVisible) {
    return null;
  }

  return (
    <Modal
      title="Custom Repost insert query"
      className="export-custom-report-insert-query-modal"
      closeAction={hideModal}
      isLoading={isFetching}
      submitAndAddAnotherAction={copyToClipboard}
      submitAndAddAnotherText="Copy to clipboard"
      submitAction={copyToClipboardAndClose}
      submitText="Copy to clipboard and close"
    >
      <>
        <textarea disabled>{query}</textarea>
      </>
    </Modal>
  );
};
